import ApiService from './api.service';

const BASE_URL = 'commission-debts';

/**
 * CommissionDebtService — gọi API công nợ commission NV (Kế toán → Công nợ → Nhân viên).
 *
 * BE docs:
 * - docs/features/voucher-commission-range.md
 * - docs/superpowers/plans/2026-05-26-voucher-commission-range.md
 */
export const CommissionDebtService = {
  /**
   * Report 1 — Tổng công nợ theo NV trong kỳ.
   * @param {Object} params { cycle: 'YYYY-MM', status?: 'PENDING'|'SETTLED'|'WAIVED' }
   */
  summary(params) {
    return ApiService.query(`${BASE_URL}/summary`, { params });
  },

  /**
   * Report 2 — Drill-down debt theo NV + kỳ.
   * @param {Object} params { employeeId, cycle, status?, page?, limit? }
   */
  list(params) {
    return ApiService.query(`${BASE_URL}`, { params });
  },

  /**
   * Report 3 — Hiệu suất voucher commission.
   * @param {Object} params { from: 'YYYY-MM-DD', to: 'YYYY-MM-DD' }
   */
  voucherPerformance(params) {
    return ApiService.query(`${BASE_URL}/voucher-performance`, { params });
  },

  /**
   * Lập phiếu thu công nợ (tạo Transaction COMMISSION_DEBT_SETTLEMENT).
   * @param {Object} body { employeeId?, cycle?, debtIds?: number[], paymentMethod, paymentNote? }
   */
  settle(body) {
    return ApiService.post(`${BASE_URL}/settle`, body);
  },

  /**
   * Miễn nợ thủ công (PENDING → WAIVED, reason >= 10 ký tự).
   * @param {number} id debt id
   * @param {Object} body { reason }
   */
  waive(id, body) {
    return ApiService.put(`${BASE_URL}/${id}/waive`, body);
  },

  /**
   * Tải file Excel export công nợ NV theo kỳ.
   * Return axios response với responseType blob — caller dùng để trigger download.
   * @param {Object} params { cycle: 'YYYY-MM', employeeName?: string }
   */
  exportExcel(params) {
    return ApiService.query(`${BASE_URL}/export`, {
      params,
      responseType: 'blob',
    });
  },

  /**
   * Upload file Excel để batch settle công nợ.
   * Response: { success, data: { totalRows, success, skipped, failed, errors, transactionIds } }
   * @param {File} file
   */
  importSettle(file) {
    const formData = new FormData();
    formData.append('file', file);
    return ApiService.post(`${BASE_URL}/import-settle`, formData, undefined);
  },
};
